const SystemType = {
    'MERCHANT_ADMIN': 'merchant-admin',
    'COMMUNE_ADMIN': 'commune-admin',
};

export default SystemType;